import actionConsts from './../../constants/actions';

const actors = (state = {}, action = {}) => {
    const { payload } = action;
    switch (action.type) {
        case actionConsts.RECEIVE_INIT_DATA:
            return payload.actors

        default: return state;
    }
}

export default actors;


// WEBPACK FOOTER //
// /src/reducers/actors/index.js